"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, type ReactNode } from "react";
import posthog from "posthog-js";
import { PostHogProvider as PHProvider, usePostHog } from "posthog-js/react";
import { useAuth } from "./auth-provider";
import { shouldResetAnalyticsIdentity } from "@/lib/auth/transition";
const POSTHOG_KEY = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN ?? process.env.NEXT_PUBLIC_POSTHOG_KEY;
const POSTHOG_HOST = process.env.NEXT_PUBLIC_POSTHOG_HOST ?? "https://us.i.posthog.com";
export function PostHogProvider(t0) {
  const $ = _c(8);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp2, t1);
  if (!POSTHOG_KEY) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <ConversionMarkerTracker />;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== children) {
      t3 = <>{t2}{children}</>;
      $[2] = children;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <UserIdentifier />;
    t3 = <ConversionMarkerTracker />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== children) {
    t4 = <PHProvider client={posthog}>{t2}{t3}{children}</PHProvider>;
    $[6] = children;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp2() {
  if (!POSTHOG_KEY) {
    return;
  }
  if (posthog.__loaded) {
    return;
  }
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    ui_host: "https://us.posthog.com",
    defaults: "2025-05-24",
    capture_pageview: true,
    capture_pageleave: true,
    capture_exceptions: true,
    person_profiles: "identified_only",
    loaded: _temp
  });
}
function _temp(ph) {
  if (process.env.NODE_ENV === "development") {
    ph.debug(false);
  }
}
function UserIdentifier() {
  const {
    user,
    profile,
    loading
  } = useAuth();
  const ph = usePostHog();
  useEffect(() => {
    if (!ph || loading) return;
    if (user) {
      let persistedUserId: unknown;
      try {
        persistedUserId = ph.get_property?.("$user_id");
      } catch {
        // Do not risk merging account B into an unreadable A identity.
        return;
      }
      if (typeof persistedUserId === "string" && shouldResetAnalyticsIdentity(persistedUserId, user.id)) {
        try {
          ph.reset();
        } catch {
          // Telemetry fails closed; auth and application UI continue.
          return;
        }
      }
      ph.identify(user.id, {
        email: user.email,
        display_name: profile?.displayName || undefined,
        is_author: profile?.canAuthor ?? false
      });
    } else {
      // Reset only if a previous identity exists, to avoid spurious distinct_id churn.
      const distinctId = ph.get_distinct_id?.();
      if (distinctId && distinctId !== ph.get_property?.("$device_id")) {
        ph.reset();
      }
    }
  }, [user, profile, loading, ph]);
  return null;
}
function ConversionMarkerTracker() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp5, t0);
  return null;
}
function _temp5() {
  const timer = window.setInterval(_temp4, 500);
  return () => window.clearInterval(timer);
}
function _temp4() {
  const marker = document.cookie.split("; ").find(_temp3);
  if (!marker) {
    return;
  }
  const event = decodeURIComponent(marker.split("=")[1] ?? "");
  document.cookie = "iloris_conversion=; Max-Age=0; Path=/";
  if (event === "SignUp") {
    window.rdt?.("track", "SignUp");
  }
}
function _temp3(part) {
  return part.startsWith("iloris_conversion=");
}